import {
  GETCARD,
  DELETECARD,
  UPDATECARD,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETCARD:
      return {
        ...state,
        cardList: action.payload.data,
      };
    case UPDATECARD:
      return {
        ...state,
        cardUpdateStatus: action.payload.success,
      };

    case DELETECARD:
      return {
        ...state,
        cardDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
